// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"e9be963c","205":"ce3f28ec","548":"9aa17395","770":"5e2ebfc5","803":"721a56ab"}[chunkId] + ".chunk.js";
};